export default function CTASection() {
  return (
    <section className="relative py-32 overflow-hidden bg-gradient-to-br from-slate-900 via-teal-900 to-slate-900">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      {/* Gradient Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-md rounded-full mb-8 border border-white/20">
          <i className="ri-customer-service-2-line text-teal-400 text-xl mr-3"></i>
          <span className="text-white text-sm font-bold">CONTACT US</span>
        </div>

        <h2 className="text-5xl md:text-6xl font-black text-white mb-8 leading-tight">
          まずは<span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">お気軽に</span>
          <br />
          ご相談ください
        </h2>

        <p className="text-xl text-gray-300 mb-12 leading-relaxed max-w-3xl mx-auto">
          会社買収に関するご質問やご不明点など、<br />
          専門スタッフが丁寧にご説明いたします
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto mb-12">
          <a
            href="mailto:info@nextage.jp"
            className="group bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-300 cursor-pointer"
          >
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-mail-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-black text-white mb-2">メールでお問い合わせ</h3>
            <p className="text-gray-300 text-sm mb-4">24時間受付中</p>
            <p className="text-teal-400 font-bold">info@nextage.jp</p>
          </a>

          <a
            href="/company-list"
            className="group bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-300 cursor-pointer"
          >
            <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-building-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-black text-white mb-2">売り会社一覧を見る</h3>
            <p className="text-gray-300 text-sm mb-4">豊富な案件からお選びいただけます</p>
            <div className="flex items-center justify-center text-cyan-400 font-bold">
              一覧を見る
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
            </div>
          </a>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <a
            href="mailto:info@nextage.jp"
            className="group px-12 py-5 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-teal-500/30 transition-all duration-300 flex items-center whitespace-nowrap cursor-pointer"
          >
            今すぐお問い合わせ
            <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
